module.exports = __webpack_public_path__ + "img/puzzle5.81945e7e.png";